import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isNotEmpty } from "../../../helpers/StringHelpers"
import getCompanySearch, { CompanyOption, NEW_COMPANY_CODE } from "../../../services/ntuc/userService/company"
import { CompanyNameValidator } from "../../../services/validation/address-employment-form/CompanyNameValidator"
import { DropDownSearch } from "../../DropDownSearch/DropDownSearch"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"
import { disableFieldCheck } from "../../../services/validation/address-employment-form/disableFieldCheck"
import { OtherCompanyNameValidator } from "../../../services/validation/address-employment-form/OtherCompanyNameValidator"

const CompanyNameField = (props: FormFieldProps<CompanyOption>) => {
    const { t } = useTranslation(`signup`)
    const [errorMessage, setErrorMessage] = useState(``)
    const [companyData, setCompanyData] = useState<CompanyOption[]>([])
    const [selectedCompany, setSelectedCompany] = useState<CompanyOption | null>(null)
    const [timer, setTimer] = useState<any>(null)
    const delayTimeMs = 500
    const {
        defaultValue,
        handleChange,
        errorText,
        dependentField,
        isDisabled,
    } = props

    useEffect(() => {
        if (disableFieldCheck.has(dependentField ?? ``)) {
            setErrorMessage(``)
            return
        }
        setErrorMessage(errorText ?? ``)
    }, [dependentField, errorText, defaultValue])

    const validateField = (text: string) => {
        const validator = selectedCompany?.code == NEW_COMPANY_CODE ? new OtherCompanyNameValidator() :new CompanyNameValidator()
        const validationText = t(validator.validate(text) ?? ``)
        setErrorMessage(validationText)
    }

    const inputChange = (value: string) => {
        clearTimeout(timer)
        const newTimer = setTimeout(() => {
            fetchCompanyData(value)
        }, delayTimeMs)
        setTimer(newTimer)
    }

    const handleOnSelect = (option: CompanyOption) => {
        handleChange(option)
        setSelectedCompany(option)

    }

    const fetchCompanyData = (text: string) => {
        if (isNotEmpty(text)) {
            getCompanySearch(text)
                .then(response => response.data.content)
                .then(setCompanyData)
        }
    }

    return (
        <DropDownSearch
            title={t(`company_name`)}
            showError={isNotEmpty(errorMessage)}
            errorMessage={t(errorMessage)}
            defaultValue={defaultValue?.name ?? ``}
            searching={false}
            options={companyData}
            onChange={inputChange}
            onSelect={handleOnSelect}
            onBlur={validateField}
            dependentField={dependentField}
            disabled={isDisabled}
        />
    )
}

export { CompanyNameField }